import { useBrandStore } from '@/stores/brand'

export const specialBackgrounds = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_dual_tone_white_638899142307229080.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_single_white_638918714950305167.png',
]

export const normalBackgrounds = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_1_white_638832432800094753.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_2_white_new_638769259843984303.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_3_white_new_638769259842020252.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_4_white_638834075860496675.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_5_white_638834075860507880.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_6_white_638834075860674725.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_43_white_638862619217902979.png',
]

export const kitchenBackgrounds = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen1.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen2.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen3.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen4.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen5.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen6.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen7.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen8.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Kitchen/kitchen9.png',
]

export const bathBackgrounds = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath1.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath2.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath3.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath4.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath5.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath6.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath7.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath8.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/AI-Backgrounds/AI-Bath/bath9.png',
]

export const overlays = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay0.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay1.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay2.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay3.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay5.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay6.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay7.png',
]

export const autofixOverlays = [
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay0.png',
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay6.png',
]

export const overlayNoneThumbnail =
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay0_Thumbnail.png'

export const overlay6Thumbnail =
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/stunnrBE/Overlays/Overlay6_Thumbnail.png'

export const transparentBackground =
  'https://s3.amazonaws.com/deltax.testing/BPs/17419/CreativeBuilder/Gallery/Images/l2_banner_bg_44_white_6388324328000947570.png'

export const aiBgAllowedBrands = [
  'gillette venus',
  'saffola',
  'rawpressery',
  'nescafe',
  'knorr',
  'kelloggs',
  'hersheys',
  'dove',
  'unibic',
  'cornitos',
  'maggi',
  'lays',
  'beardo',
  'wildstone',
  'mcaffeine',
  'gillette',
  'doritos',
  'olay',
  'raffertys Garden',
  'gatorade',
  "President's Choice",
  'Red Bull',
  'Neutrogena',
  'St Ives',
  "Reese's",
  "Kellogg's",
]

export const AI_BACKGROUND_TEXT_COLOR = '#000000'
export const BACKDROP_TEXT_COLORS = ['#000000', '#ffffff']

export const getBackground = (index: number): string => {
  if (index % 3 === 0) {
    const randomIndex = Math.floor(Math.random() * normalBackgrounds.length)
    return normalBackgrounds[randomIndex]
  }
  if (index % 3 === 1) {
    // AI would suggest the optimal background
    const brandStore = useBrandStore()
    const selectedBrandName = brandStore.selectedBrand?.name || ''
    if (aiBgAllowedBrands.includes(selectedBrandName)) {
      return ''
    }
    const randomIndex = Math.floor(Math.random() * normalBackgrounds.length)
    return normalBackgrounds[randomIndex]
  }
  if (index % 3 === 2) {
    const randomIndex = Math.floor(Math.random() * specialBackgrounds.length)
    return specialBackgrounds[randomIndex]
  }
  return normalBackgrounds[0] // Fallback to the first background
}
